import React, { useState, useEffect } from 'react';
import '../../css/Pages.css';
import EducationLevelListing from '../../components/CategoryManagement/EducationLevel/EducationLevelListing';

const EducationLevel = () => {
    const [educationLevels, setEducationLevels] = useState([]);
    const [filteredEducationLevels, setFilteredEducationLevels] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const [isDesktop, setIsDesktop] = useState(true);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 992);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        fetchEducationLevels();
    }, []);

    const fetchEducationLevels = async () => {
        setIsLoading(true);
        try {
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

            const response = await fetch(`${API_BASE_URL}/educationlevel`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 401 || response.status === 403) {
                localStorage.removeItem('user');
                localStorage.removeItem('accessToken');
                window.location.href = '/login';
                return;
            }

            if (response.ok) {
                const data = await response.json();

                if (Array.isArray(data)) {
                    setEducationLevels(data);
                    setFilteredEducationLevels(data);
                } else {
                    console.error("Lỗi: Dữ liệu API trả về không phải là mảng", data);
                    setEducationLevels([]);
                    setFilteredEducationLevels([]);
                }
            } else {
                console.error("Lỗi HTTP:", response.status);
                setEducationLevels([]);
                setFilteredEducationLevels([]);
            }
        } catch (error) {
            console.error("Lỗi khi tải dữ liệu Trình độ từ máy chủ:", error);
            setEducationLevels([]);
            setFilteredEducationLevels([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        const filtered = educationLevels.filter(level =>
            level.Name.toLowerCase().includes(query) ||
            level.Code.toLowerCase().includes(query)
        );
        setFilteredEducationLevels(filtered);
    };

    return (
        <div className="page-container">
            <div className="page-header" style={{ marginBottom: '10px' }}>
                <div className="header-title">
                    <h2>DANH MỤC TRÌNH ĐỘ</h2>
                </div>
            </div>

            <div style={isDesktop
                ? { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }
                : { display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '20px' }
            }>
                <p className="sub-title" style={{ margin: 0 }}>DANH SÁCH TRÌNH ĐỘ</p>

                <div style={isDesktop
                    ? { display: 'flex', gap: '10px' }
                    : { display: 'flex', gap: '10px', width: '100%', alignItems: 'stretch' }
                }>
                    <div style={isDesktop ? {} : { flex: 1 }}>
                        <input
                            type="text"
                            placeholder="Tra cứu trình độ hoặc mã"
                            className="form-input"
                            style={isDesktop
                                ? { width: '300px', padding: '8px 15px' }
                                : { width: '100%', padding: '8px 15px', boxSizing: 'border-box', height: '100%' }
                            }
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    </div>
                    <button
                        onClick={fetchEducationLevels}
                        className="btn-add-new"
                        style={isDesktop
                            ? { margin: 0, padding: '8px 15px', backgroundColor: '#6c757d' }
                            : { margin: 0, padding: '0', width: '45px', flex: '0 0 45px', backgroundColor: '#6c757d', display: 'flex', justifyContent: 'center', alignItems: 'center' }
                        }
                        title="Tải lại dữ liệu"
                    >
                        <i className="fa-solid fa-rotate-right"></i>
                    </button>
                </div>
            </div>

            <EducationLevelListing
                data={filteredEducationLevels}
                searchQuery={searchQuery}
                isLoading={isLoading}
            />
        </div>
    );
};

export default EducationLevel;